import request from '@/utils/request'

// 获取用户列表
export function GetUserList(data) {
  return request({
    url: '/car/user/data',
    method: 'post',
    data
  })
}
// 获取权限列表
export function GetRoleList() {
  return request({
    url: '/car/user/getRoleList',
    method: 'post'
  })
}
// 获取用户详情
export function GetUserDeatil(data) {
  return request({
    url: '/car/user/getDetail',
    method: 'post',
    data
  })
}
// 获取用户详情
export function GetUserPersonal(data) {
  return request({
    url: '/car/user/getPersonal',
    method: 'post',
    data
  })
}
export function deleteUser(data) {
  return request({
    url: '/car/user/deleteById',
    method: 'post',
    data
  })
}

// 设置用户详情
export function SetUserDeatil(data) {
  return request({
    url: '/car/user/setDetail',
    method: 'post',
    data
  })
}
// 获取目录权限
export function GetMenu() {
  return request({
    url: '/data/getMenu',
    method: 'post'
  })
}

// 重置密码
export function resetPasw(data) {
  return request({
    url: '/car/user/resetPasw',
    method: 'post',
    data
  })
}

// 获取公司信息
export function getCompanys(data) {
  return request({
    url: '/car/userm/getCompanys',
    method: 'get',
    params:data
  })
}
// 获取角色
export function getRoleData(data) {
  return request({
    url: '/car/userm/getRoleList',
    method: 'get',
    params:data
  })
}
// 新增账号
export function addAccount(data) {
  return request({
    url: '/car/userm/add',
    method: 'post',
    data
  })
}
// 修改账号
export function editAccount(data) {
  return request({
    url: '/car/userm/setUser',
    method: 'post',
    data
  })
}
// 删除账号
export function delAccount(data) {
  return request({
    url: '/car/userm/deleteById',
    method: 'post',
    params:data
  })
}
// 重置密码
export function resetAccount(data) {
  return request({
    url: '/car/userm/resetPasw',
    method: 'post',
    params:data
  })
}
// 查询用户列表
export function getAccountList(data) {
  return request({
    url: '/car/userm/getUserList',
    method: 'get',
    params:data
  })
}